import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Header from '../../main/components/Header';

import Offers from './Offers';

const OffersLayout: React.FC = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'ofertas-campanhas'])}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <Header title={t('offers:header')} />
                    <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                        <Offers />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OffersLayout;
